module.exports = __webpack_public_path__ + "static/media/movie-seat-booking-sc.b7155d2c.png";